import { Fragment, useEffect, useRef, useState } from 'react';

import CloseIcon from '@/components/Icon/CloseIcon';
import UploadIcon from '@/components/Icon/UploadIcon';

import * as S from './style';

export interface IPastData {
	filePk: number;
	fileName: string;
	fileSize: number;
}
interface InputFilesProps {
	files: File[];
	setFiles: React.Dispatch<React.SetStateAction<File[]>>;
	pastData?: IPastData[];
	pastDataDeleteAction?: (pk: number) => void;
}

export default function FileUploadComponent({ files, setFiles, pastData, pastDataDeleteAction }: InputFilesProps) {
	const [isDragging, setIsDragging] = useState<boolean>(false);
	const fileInputRef = useRef<HTMLInputElement | null>(null);

	const formatBytesToKB = (bytes: number) => `${Math.round(bytes / 1024)} KB`;

	const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragging(true);
	};
	const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragging(false);
	};
	const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
		if (!isDragging) {
			setIsDragging(true);
		}
	};
	const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
		setIsDragging(false);

		if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
			handleFiles(e.dataTransfer.files);
			e.dataTransfer.clearData();
		}
	};
	const handleFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files.length > 0) {
			handleFiles(e.target.files);
		}
	};
	const handleFiles = (fileList: FileList) => {
		const newFiles = Array.from(fileList);
		setFiles((prevFiles) => [...prevFiles, ...newFiles]);
	};
	const triggerFileInput = () => {
		fileInputRef.current?.click();
	};
	const removeFile = (indexToRemove: number) => {
		setFiles((prevFiles) => prevFiles.filter((_, index) => index !== indexToRemove));
		// + delFilePks 로직
	};

	return (
		<S.Container>
			<S.DropZone
				isDragging={isDragging}
				onDragEnter={handleDragEnter}
				onDragOver={handleDragOver}
				onDragLeave={handleDragLeave}
				onDrop={handleDrop}
				onClick={triggerFileInput}
			>
				<S.HiddenInput type="file" ref={fileInputRef} onChange={handleFileInputChange} multiple />

				<S.DropText>드래그 혹은 파일 업로드</S.DropText>
				<UploadIcon />
			</S.DropZone>

			{pastData && pastData.length > 0 && (
				<S.FileList>
					<S.FileListUl>
						{pastData.map((pastFile, index) => (
							<S.FileItem key={index}>
								<S.FileContent>
									<div className="title">{pastFile.fileName ?? ''}</div>
									<div className="sub_title">{formatBytesToKB(pastFile.fileSize ?? 0)}</div>
								</S.FileContent>
								<div
									onClick={(e: any) => {
										e.stopPropagation();
										pastDataDeleteAction?.(pastFile.filePk);
									}}
								>
									<CloseIcon iconColor="#ADB5BD" width="20" height="20" />
								</div>
							</S.FileItem>
						))}
					</S.FileListUl>
				</S.FileList>
			)}
			{files.length > 0 && (
				<S.FileList>
					<S.FileListUl>
						{files.map((file, index) => (
							<S.FileItem key={index}>
								<S.FileContent>
									<div className="title">{file.name ?? ''}</div>
									<div className="sub_title">{formatBytesToKB(file.size ?? 0)}</div>
								</S.FileContent>
								<div
									onClick={(e: any) => {
										e.stopPropagation();
										removeFile(index);
									}}
								>
									<CloseIcon iconColor="#ADB5BD" width="20" height="20" />
								</div>
							</S.FileItem>
						))}
					</S.FileListUl>
				</S.FileList>
			)}
		</S.Container>
	);
}
